import { Box, type ChipProps, styled } from "@mui/material"
import { type ChipVariation, TinyChip } from "@pharmupp/p3-front-commons"
import { forwardRef } from "react"
import { Check } from "react-feather"

export interface OfferTag extends ChipProps {
  chipVariation?: ChipVariation
  checked?: boolean
}

export const OfferTag = forwardRef<HTMLDivElement, OfferTag>(
  ({ chipVariation, checked, ...props }, ref) => (
    <TinyChip
      ref={ref}
      variation={chipVariation}
      icon={
        checked ? (
          <CheckWrapper>
            <Check size={11} />
          </CheckWrapper>
        ) : undefined
      }
      {...props}
    />
  ),
)

const CheckWrapper = styled(Box)(({ theme: { palette } }) => ({
  width: "18px",
  height: "18px",
  border: `1px solid ${palette.purple.dark3}`,
  backgroundColor: "white",
  color: palette.purple.dark3,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "100px",
}))
